import { ColumnDef } from "@tanstack/react-table"
import { formatDateAndTime } from "@/lib/utils"
import { DataTableColumnHeader } from "@/components/data-table"
import type { LedgerEntryType } from "@/lib/api/ledger"

export const consumerLedgerColumns: ColumnDef<LedgerEntryType>[] = [
  {
    id: "trans_type",
    accessorKey: "trans_type",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Transaction" />
    ),
    cell: ({ getValue }) => <span>{getValue() as string}</span>,
  },
  {
    id: "trans_date",
    accessorKey: "trans_date",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Date" />
    ),
    cell: ({ getValue }) => (
      <span>{formatDateAndTime(getValue() as string)}</span>
    ),
  },
  {
    id: "reference",
    accessorKey: "reference",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Reference" />
    ),
    cell: ({ getValue }) => <span>{getValue() as string}</span>,
  },
  {
    id: "reading",
    accessorKey: "reading",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Reading" />
    ),
    cell: ({ getValue }) => (
      <span>{getValue() != null ? (getValue() as number) : "-"}</span>
    ),
  },
  {
    id: "volume",
    accessorKey: "volume",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Volume" />
    ),
    cell: ({ getValue }) => (
      <span>{getValue() != null ? (getValue() as number) : "-"}</span>
    ),
  },
  {
    id: "others",
    accessorKey: "others",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Others (₱)" />
    ),
    cell: ({ getValue }) => (
      <span>
        {getValue() != null ? `₱${(getValue() as number).toFixed(2)}` : "-"}
      </span>
    ),
  },
  {
    id: "bill_amount",
    accessorKey: "bill_amount",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Bill Amount (₱)" />
    ),
    cell: ({ getValue }) => (
      <span>
        {getValue() != null ? `₱${(getValue() as number).toFixed(2)}` : "-"}
      </span>
    ),
  },
  {
    id: "debit",
    accessorKey: "debit",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Debit (₱)" />
    ),
    cell: ({ getValue }) => (
      <span>₱{(getValue() as number)?.toFixed(2)}</span>
    ),
  },
  {
    id: "credit",
    accessorKey: "credit",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Credit (₱)" />
    ),
    cell: ({ getValue }) => (
      <span>₱{(getValue() as number)?.toFixed(2)}</span>
    ),
  },
  {
    id: "balance",
    accessorKey: "balance",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Balance (₱)" />
    ),
    cell: ({ getValue }) => (
      <span>₱{(getValue() as number)?.toFixed(2)}</span>
    ),
  },
  {
    id: "modified_by",
    accessorKey: "modified_by",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Modified By" />
    ),
    cell: ({ getValue }) => <span>{getValue() as string}</span>,
  },
]
